<template>
  <div v-if="!showRequest">
    <app-history @clicked="$router.push('/delete-course-history')" />
    <v-card class="fullForm">
      <div class="fullText">
        <b>طلبه گرامی:</b>
        <br />
        <br />
        چنانچه تقاضای حذف یکی از دروس خود را دارید، درس مورد نظر خود را انتخاب
        نموده و تقاضای حذف آن را ارسال فرمائید.
        <br />
        تقاضای شما توسط مسئول آموزش مدرسه مورد بررسی قرار گرفته و در صورت
        صلاحدید ایشان درس حذف خواهد شد.
        <br />
        شما می توانید از بخش مشاهده سوابق از نتیجه تقاضای خود اطلاع حاصل
        فرمائید.
        <br />
        <br />
      </div>
      <v-row class="ltr">
        <v-btn color="primary white--text" class="request" rounded @click="onClickNew">
          درخواست حذف درس
        </v-btn>
      </v-row>
    </v-card>
  </div>
  <div v-else>
    <v-card class="form">
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6">
          <b>درس:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-select :items="courses" item-text="Text" item-value="Value" item-disabled="Disabled" v-model="course"
            no-data-text="درسی موجود نیست"></v-select>
        </v-col>
      </v-row>

      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6">
          <b>توضیحات:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-textarea outlined v-model="comment" no-resize></v-textarea>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6">
          <v-file-input label="مستندات حذف درس" v-model="image"></v-file-input>
        </v-col>
      </v-row>
      <v-row class="ltr">
        <v-btn color="primary white--text" class="register" rounded @click="applyRequest">
          ثبت درخواست
        </v-btn>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { requestDelete } from "@/api/delete-course";
import HistoryButton from "@/components/HistoryButton";
export default {
  data() {
    return {
      showRequest: false,
      course: "",
      comment: "",
      image: null,
    };
  },
  components: {
    appHistory: HistoryButton,
  },
  methods: {
    onClickNew() {
      if (this.courses.length > 0) {
        window.scrollTo(0, 0);
        this.$router.push({
          query: {

            showRequest: "true"
          }
        });
      } else {
        this.$store.commit(
          "SET_SNACKBAR_TEXT",
          "هم اکنون مجاز به ارسال درخواست حذف نیستید"
        );
      }
    },
    applyRequest() {
      var text = "";
      if (!this.course) {
        text = "لطفا درس را انتخاب کنید.";
      }
      if (text != "") {
        this.$store.commit("SET_SNACKBAR_TEXT", text);

        return;
      } else {
        requestDelete(this.image, this.course, this.comment)
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.Message);

            if (data.Success) {
              this.$store.dispatch("getDeleteableCourses");
              this.course = "";
              this.comment = "";
              this.image = null;
            }
          })

          .catch((error) => {
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
    },
  },

  created() {
    if (this.$route.query.showRequest) {
      this.$router.replace({
        query: {}
      })
    }
    this.$store.dispatch("getDeleteableCourses");
  },
  computed: {
    courses() {
      return this.$store.getters.deleteableCourses;
    },
  },
  watch: {

    '$route'(to, from) {
      this.showRequest = !!this.$route.query.showRequest;
    }
  },
};
</script>
<style scoped>
.v-card__title {
  border-radius: 15px !important;
}

.request {
  width: 300px !important;
  margin: 15px;
}

.register {
  width: 300px !important;
  margin: 15px auto;
}

@media only screen and (min-width: 600px) {
  .form {
    width: 570px;
    margin: 15px auto;
  }

  .col-12 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
}
</style>
